import React from 'react';
import { DollarSign, Eye, TrendingUp, Loader2 } from 'lucide-react';

type MetricCardType = 'revenue' | 'netRevenue' | 'impressions' | 'cpm';

const ICONS: Record<MetricCardType, React.FC<{ className?: string }>> = {
  revenue: DollarSign,
  netRevenue: DollarSign,
  impressions: Eye,
  cpm: TrendingUp,
};

interface MetricCardProps {
  title: string;
  value: string;
  type: MetricCardType;
  loading?: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, type, loading }) => {
  const Icon = ICONS[type];
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5">
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs uppercase tracking-wide text-slate-500">{title}</div>
        <Icon className="w-4 h-4 text-slate-400" />
      </div>
      {loading ? (
        <Loader2 className="w-6 h-6 text-slate-300 animate-spin" />
      ) : (
        <div className="text-3xl font-bold text-slate-900">{value}</div>
      )}
    </div>
  );
};

export default MetricCard;
